<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="9.098" width="12.398">
    <path d="M11.352 4.549H-.001M7.445.522l3.908 4.027-3.908 4.026" fill="none" stroke="#CECECE" stroke-width="1.5"/>
  </svg>
</template>
